import { useState, useEffect, type RefObject } from "react";  

export function useTextSelection(containerRef?: RefObject<HTMLElement>) {
  const [selection, setSelection] = useState<{
    text: string;
    rect: DOMRect | null;
  }>({ text: "", rect: null });

  useEffect(() => {
    const handleSelection = () => {
      const sel = window.getSelection();
      if (!sel || sel.isCollapsed) {
        setSelection({ text: "", rect: null });
        return;
      }
      if (sel.rangeCount === 0) {
        setSelection({ text: "", rect: null });
        return;
      }
      const range = sel.getRangeAt(0);

      // If a container is provided, only capture selections within it
      if (containerRef?.current) {
        const container = containerRef.current;
        const common = range.commonAncestorContainer;
        const commonElement = common.nodeType === 1 ? (common as Element) : (common.parentElement as Element | null);
        if (!commonElement || !container.contains(commonElement)) {
          setSelection({ text: "", rect: null });
          return;
        }
      }
      const rect = range.getBoundingClientRect();
      setSelection({ text: sel.toString(), rect });
    };

    document.addEventListener("mouseup", handleSelection);
    document.addEventListener("keyup", handleSelection); // catch keyboard selections
    return () => {
      document.removeEventListener("mouseup", handleSelection);
      document.removeEventListener("keyup", handleSelection);
    };
  }, []);

  return selection;
}
